import { defineComponent as r, createBlock as o, openBlock as p, unref as i, mergeProps as c, withCtx as h, createElementVNode as a } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const v = /* @__PURE__ */ r({
  name: "IconChargingWire",
  __name: "IconChargingWire",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (m, e) => (p(), o(i(l), c(n, { "view-box": "0 0 24 24" }), {
      default: h(() => [...e[0] || (e[0] = [
        a("path", { d: "M14.5 9.75H6v5.75a1.75 1.75 0 0 0 1.75 1.75h5a1.75 1.75 0 0 0 1.75-1.75V9.75M16 15.5a3.25 3.25 0 0 1-3.25 3.25h-5A3.25 3.25 0 0 1 4.5 15.5v-6a1.25 1.25 0 0 1 1.25-1.25h9A1.25 1.25 0 0 1 16 9.5v6" }, null, -1),
        a("path", { d: "M15 9h-1.5V3.75H7V9H5.5V3.5a1.25 1.25 0 0 1 1.25-1.25h7A1.25 1.25 0 0 1 15 3.5V9m2.239 8.232 2.018-3.172c.183-.287.627-.097.545.233L19.25 16.5h1.63a.5.5 0 0 1 .431.752l-2.092 3.586c-.172.296-.626.118-.552-.216L19.25 18h-1.59a.5.5 0 0 1-.421-.768M9.5 21v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
